export const ORDER_STATUS_LIST_CLEAR_STORE = "ORDER_STATUS_LIST_CLEAR_STORE";

export const ORDER_STATUS_LIST_SUMMURY_LOAD_START = "ORDER_STATUS_LIST_SUMMURY_LOAD_START";
export const ORDER_STATUS_LIST_SUMMURY_LOAD_SUCCESS = "ORDER_STATUS_LIST_SUMMURY_LOAD_SUCCESS";
export const ORDER_STATUS_LIST_SUMMURY_LOAD_FAIL = "ORDER_STATUS_LIST_SUMMURY_LOAD_FAIL";

export const ORDER_STATUS_LIST_LOAD_START = "ORDER_STATUS_LIST_LOAD_START";
export const ORDER_STATUS_LIST_LOAD_SUCCESS = "ORDER_STATUS_LIST_LOAD_SUCCESS";
export const ORDER_STATUS_LIST_LOAD_FAIL = "ORDER_STATUS_LIST_LOAD_FAIL";

export const ORDER_STATUS_LIST_REMOVE_START = "ORDER_STATUS_LIST_REMOVE_START";
export const ORDER_STATUS_LIST_REMOVE_SUCCESS = "ORDER_STATUS_LIST_REMOVE_SUCCESS";
export const ORDER_STATUS_LIST_REMOVE_FAIL = "ORDER_STATUS_LIST_REMOVE_FAIL";
